import Highcharts from 'highcharts';
import HighchartsComponentBase from "./common/HighchartsComponentBase.js";
import * as utils from "./misc/utils.js";
import { createRCCAndRegions, createSVFAndTreatment } from './common/DropdownHelper.js'


const template = `
<style>
.skr-select {
  height:35px; 
  border:1px solid #ddd; 
  padding-left: 6px;
  font-weight: 300;
  padding: .375rem .75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: .25rem;
  transition: border-color .15s;
  margin-right: 8px;
  margin-top: 8px;
}
.highcharts-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    text-align: left;
    line-height: normal;
    z-index: 0;
    /* #1072 */
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif;
    font-size: 12px;
    user-select: none;
  }
  
  .highcharts-root {
    display: block;
  }
  
  .highcharts-root text {
    stroke-width: 0;
  }
  
  .highcharts-strong {
    font-weight: bold;
  }
  
  .highcharts-emphasized {
    font-style: italic;
  }
  
  .highcharts-anchor {
    cursor: pointer;
  }
  
  .highcharts-background {
    fill: #ffffff;
  }
  
  .highcharts-plot-border, .highcharts-plot-background {
    fill: none;
  }
  
  .highcharts-label-box {
    fill: none;
  }
  
  .highcharts-button-box {
    fill: inherit;
  }
  
  .highcharts-tracker-line {
    stroke-linejoin: round;
    stroke: rgba(192, 192, 192, 0.0001);
    stroke-width: 22;
    fill: none;
  }
  
  .highcharts-tracker-area {
    fill: rgba(192, 192, 192, 0.0001);
    stroke-width: 0;
  }
  
  /* Titles */
  .highcharts-title {
    fill: #333333;
    font-size: 1.5em;
  }
  
  .highcharts-subtitle {
    fill: #666666;
  }
  
  /* Axes */
  .highcharts-axis-line {
    fill: none;
    stroke: #ccd6eb;
  }
  
  .highcharts-yaxis .highcharts-axis-line {
    stroke-width: 0;
  }
  
  .highcharts-axis-title {
    fill: #666666;
  }
  
  .highcharts-axis-labels {
    fill: #666666;
    cursor: default;
    font-size: 0.9em;
  }
  
  .highcharts-grid-line {
    fill: none;
    stroke: #e6e6e6;
  }
  
  .highcharts-xaxis-grid .highcharts-grid-line {
    stroke-width: 0px;
  }
  
  .highcharts-tick {
    stroke: #ccd6eb;
  }
  
  .highcharts-yaxis .highcharts-tick {
    stroke-width: 0;
  }
  
  .highcharts-minor-grid-line {
    stroke: #f2f2f2;
  }
  
  .highcharts-crosshair-thin {
    stroke-width: 1px;
    stroke: #cccccc;
  }
  
  .highcharts-crosshair-category {
    stroke: #ccd6eb;
    stroke-opacity: 0.25;
  }
  
  /* Credits */
  .highcharts-credits {
    cursor: pointer;
    fill: #999999;
    font-size: 0.7em;
    transition: fill 250ms, font-size 250ms;
  }
  
  .highcharts-credits:hover {
    fill: black;
    font-size: 1em;
  }
  
  /* Tooltip */
  .highcharts-tooltip {
    cursor: default;
    pointer-events: none;
    white-space: nowrap;
    transition: stroke 150ms;
  }
  
  .highcharts-tooltip text {
    fill: #333333;
  }
  
  .highcharts-tooltip .highcharts-header {
    font-size: 0.85em;
  }
  
  .highcharts-tooltip-box {
    stroke-width: 1px;
    fill: #f7f7f7;
    fill-opacity: 0.85;
  }
  
  .highcharts-tooltip-box .highcharts-label-box {
    fill: #f7f7f7;
    fill-opacity: 0.85;
  }
  
  div.highcharts-tooltip {
    filter: none;
  }
  
  .highcharts-selection-marker {
    fill: #335cad;
    fill-opacity: 0.25;
  }
  
  .highcharts-graph {
    fill: none;
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  
  .highcharts-empty-series {
    stroke-width: 1px;
    fill: none;
    stroke: #cccccc;
  }
  
  .highcharts-state-hover .highcharts-graph {
    stroke-width: 3;
  }
  
  .highcharts-point-inactive {
    opacity: 0.2;
    transition: opacity 50ms;
    /* quick in */
  }
  
  .highcharts-series-inactive {
    opacity: 0.2;
    transition: opacity 50ms;
    /* quick in */
  }
  
  .highcharts-state-hover path {
    transition: stroke-width 50ms;
    /* quick in */
  }
  
  .highcharts-state-normal path {
    transition: stroke-width 250ms;
    /* slow out */
  }
  
  /* Legend hover affects points and series */
  g.highcharts-series,
  .highcharts-point,
  .highcharts-markers,
  .highcharts-data-labels {
    transition: opacity 250ms;
  }
  
  .highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),
  .highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover),
  .highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),
  .highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover) {
    opacity: 0.2;
  }
  
  /* Series options */
  /* Default colors */
  .highcharts-color-9 {
    fill: #91e8e1;
    stroke: #91e8e1;
  }
  
  .highcharts-area {
    fill-opacity: 0.75;
    stroke-width: 0;
  }
  
  .highcharts-markers {
    stroke-width: 1px;
    stroke: #ffffff;
  }
  
  .highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover):not(.highcharts-a11y-marker-visible),
  .highcharts-a11y-marker-hidden {
    opacity: 0;
  }
  
  .highcharts-point {
    stroke-width: 1px;
  }
  
  .highcharts-dense-data .highcharts-point {
    stroke-width: 0;
  }
  
  .highcharts-data-label {
    font-size: 0.9em;
    font-weight: bold;
  }
  
  .highcharts-data-label-box {
    fill: none;
    stroke-width: 0;
  }
  
  .highcharts-data-label text, text.highcharts-data-label {
    fill: #333333;
  }
  
  .highcharts-data-label-connector {
    fill: none;
  }
  
  .highcharts-data-label-hidden {
    pointer-events: none;
  }
  
  .highcharts-halo {
    fill-opacity: 0.25;
    stroke-width: 0;
  }
  
  .highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,
  .highcharts-markers .highcharts-point-select {
    fill: #cccccc;
    stroke: #000000;
  }
  
  .highcharts-column-series rect.highcharts-point {
    stroke: #ffffff;
  }
  
  .highcharts-column-series .highcharts-point {
    transition: fill-opacity 250ms;
  }
  
  .highcharts-column-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }
  
  .highcharts-pie-series .highcharts-point {
    stroke-linejoin: round;
    stroke: #ffffff;
  }
  
  .highcharts-pie-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }
  
  .highcharts-funnel-series .highcharts-point {
    stroke-linejoin: round;
    stroke: #ffffff;
  }
  
  .highcharts-funnel-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }
  
  .highcharts-funnel-series .highcharts-point-select {
    fill: inherit;
    stroke: inherit;
  }
  
  .highcharts-pyramid-series .highcharts-point {
    stroke-linejoin: round;
    stroke: #ffffff;
  }
  
  .highcharts-pyramid-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }
  
  .highcharts-pyramid-series .highcharts-point-select {
    fill: inherit;
    stroke: inherit;
  }
  
  .highcharts-solidgauge-series .highcharts-point {
    stroke-width: 0;
  }
  
  .highcharts-treemap-series .highcharts-point {
    stroke-width: 1px;
    stroke: #e6e6e6;
    transition: stroke 250ms, fill 250ms, fill-opacity 250ms;
  }
  
  .highcharts-treemap-series .highcharts-point-hover {
    stroke: #999999;
    transition: stroke 25ms, fill 25ms, fill-opacity 25ms;
  }
  
  .highcharts-treemap-series .highcharts-above-level {
    display: none;
  }
  
  .highcharts-treemap-series .highcharts-internal-node {
    fill: none;
  }
  
  .highcharts-treemap-series .highcharts-internal-node-interactive {
    fill-opacity: 0.15;
    cursor: pointer;
  }
  
  .highcharts-treemap-series .highcharts-internal-node-interactive:hover {
    fill-opacity: 0.75;
  }
  
  .highcharts-vector-series .highcharts-point {
    fill: none;
    stroke-width: 2px;
  }
  
  .highcharts-windbarb-series .highcharts-point {
    fill: none;
    stroke-width: 2px;
  }
  
  .highcharts-lollipop-stem {
    stroke: #000000;
  }
  
  .highcharts-focus-border {
    fill: none;
    stroke-width: 2px;
  }
  
  .highcharts-legend-item-hidden .highcharts-focus-border {
    fill: none !important;
  }
  
  /* Legend */
  .highcharts-legend-box {
    fill: none;
    stroke-width: 0;
  }
  
  .highcharts-legend-item > text {
    fill: #333333;
    font-weight: bold;
    font-size: 1em;
    cursor: pointer;
    stroke-width: 0;
  }
  
  .highcharts-legend-item:hover text {
    fill: #000000;
  }
  
  .highcharts-legend-item-hidden * {
    fill: #cccccc !important;
    stroke: #cccccc !important;
    transition: fill 250ms;
  }
  
  .highcharts-legend-nav-active {
    fill: #003399;
    cursor: pointer;
  }
  
  .highcharts-legend-nav-inactive {
    fill: #cccccc;
  }
  
  circle.highcharts-legend-nav-active, circle.highcharts-legend-nav-inactive {
    /* tracker */
    fill: rgba(192, 192, 192, 0.0001);
  }
  
  .highcharts-legend-title-box {
    fill: none;
    stroke-width: 0;
  }
  
  /* Bubble legend */
  .highcharts-bubble-legend-symbol {
    stroke-width: 2;
    fill-opacity: 0.5;
  }
  
  .highcharts-bubble-legend-connectors {
    stroke-width: 1;
  }
  
  .highcharts-bubble-legend-labels {
    fill: #333333;
  }
  
  /* Loading */
  .highcharts-loading {
    position: absolute;
    background-color: #ffffff;
    opacity: 0.5;
    text-align: center;
    z-index: 10;
    transition: opacity 250ms;
  }
  
  .highcharts-loading-hidden {
    height: 0 !important;
    opacity: 0;
    overflow: hidden;
    transition: opacity 250ms, height 250ms step-end;
  }
  
  .highcharts-loading-inner {
    font-weight: bold;
    position: relative;
    top: 45%;
  }
  
  /* Plot bands and polar pane backgrounds */
  .highcharts-plot-band, .highcharts-pane {
    fill: #000000;
    fill-opacity: 0.05;
  }
  
  .highcharts-plot-line {
    fill: none;
    stroke: #999999;
    stroke-width: 1px;
  }
  
  /* Highcharts More and modules */
  .highcharts-boxplot-box {
    fill: #ffffff;
  }
  
  .highcharts-boxplot-median {
    stroke-width: 2px;
  }
  
  .highcharts-bubble-series .highcharts-point {
    fill-opacity: 0.5;
  }
  
  .highcharts-errorbar-series .highcharts-point {
    stroke: #000000;
  }
  
  .highcharts-gauge-series .highcharts-data-label-box {
    stroke: #cccccc;
    stroke-width: 1px;
  }
  
  .highcharts-gauge-series .highcharts-dial {
    fill: #000000;
    stroke-width: 0;
  }
  
  .highcharts-polygon-series .highcharts-graph {
    fill: inherit;
    stroke-width: 0;
  }
  
  .highcharts-waterfall-series .highcharts-graph {
    stroke: #333333;
    stroke-dasharray: 1, 3;
  }
  
  .highcharts-sankey-series .highcharts-point {
    stroke-width: 0;
  }
  
  .highcharts-sankey-series .highcharts-link {
    transition: fill 250ms, fill-opacity 250ms;
    fill-opacity: 0.5;
  }
  
  .highcharts-sankey-series .highcharts-point-hover.highcharts-link {
    transition: fill 50ms, fill-opacity 50ms;
    fill-opacity: 1;
  }
  
  .highcharts-venn-series .highcharts-point {
    fill-opacity: 0.75;
    stroke: #cccccc;
    transition: stroke 250ms, fill-opacity 250ms;
  }
  
  .highcharts-venn-series .highcharts-point-hover {
    fill-opacity: 1;
    stroke: #cccccc;
  }
  
  /* Highstock */
  .highcharts-navigator-mask-outside {
    fill-opacity: 0;
  }
  
  .highcharts-navigator-mask-inside {
    fill: #6685c2;
    /* navigator.maskFill option */
    fill-opacity: 0.25;
    cursor: ew-resize;
  }
  
  .highcharts-navigator-outline {
    stroke: #cccccc;
    fill: none;
  }
  
  .highcharts-navigator-handle {
    stroke: #cccccc;
    fill: #f2f2f2;
    cursor: ew-resize;
  }
  
  .highcharts-navigator-series {
    fill: #335cad;
    stroke: #335cad;
  }
  
  .highcharts-navigator-series .highcharts-graph {
    stroke-width: 1px;
  }
  
  .highcharts-navigator-series .highcharts-area {
    fill-opacity: 0.05;
  }
  
  .highcharts-navigator-xaxis .highcharts-axis-line {
    stroke-width: 0;
  }
  
  .highcharts-navigator-xaxis .highcharts-grid-line {
    stroke-width: 1px;
    stroke: #e6e6e6;
  }
  
  .highcharts-navigator-xaxis.highcharts-axis-labels {
    fill: #999999;
  }
  
  .highcharts-navigator-yaxis .highcharts-grid-line {
    stroke-width: 0;
  }
  
  .highcharts-scrollbar-thumb {
    fill: #cccccc;
    stroke: #cccccc;
    stroke-width: 1px;
  }
  
  .highcharts-scrollbar-button {
    fill: #e6e6e6;
    stroke: #cccccc;
    stroke-width: 1px;
  }
  
  .highcharts-scrollbar-arrow {
    fill: #666666;
  }
  
  .highcharts-scrollbar-rifles {
    stroke: #666666;
    stroke-width: 1px;
  }
  
  .highcharts-scrollbar-track {
    fill: #f2f2f2;
    stroke: #f2f2f2;
    stroke-width: 1px;
  }
  
  .highcharts-button {
    fill: #f7f7f7;
    stroke: #cccccc;
    cursor: default;
    stroke-width: 1px;
    transition: fill 250ms;
  }
  
  .highcharts-button text {
    fill: #333333;
  }
  
  .highcharts-button-hover {
    transition: fill 0ms;
    fill: #e6e6e6;
    stroke: #cccccc;
  }
  
  .highcharts-button-hover text {
    fill: #333333;
  }
  
  .highcharts-button-pressed {
    font-weight: bold;
    fill: #e6ebf5;
    stroke: #cccccc;
  }
  
  .highcharts-button-pressed text {
    fill: #333333;
    font-weight: bold;
  }
  
  .highcharts-button-disabled text {
    fill: #333333;
  }
  
  .highcharts-range-selector-buttons .highcharts-button {
    stroke-width: 0px;
  }
  
  .highcharts-range-label rect {
    fill: none;
  }
  
  .highcharts-range-label text {
    fill: #666666;
  }
  
  .highcharts-range-input rect {
    fill: none;
  }
  
  .highcharts-range-input text {
    fill: #333333;
  }
  
  .highcharts-range-input {
    stroke-width: 1px;
    stroke: #cccccc;
  }
  
  input.highcharts-range-selector {
    position: absolute;
    border: 0;
    width: 1px;
    /* Chrome needs a pixel to see it */
    height: 1px;
    padding: 0;
    text-align: center;
    left: -9em;
    /* #4798 */
  }
  
  .highcharts-crosshair-label text {
    fill: #ffffff;
    font-size: 1.1em;
  }
  
  .highcharts-crosshair-label .highcharts-label-box {
    fill: inherit;
  }
  
  .highcharts-candlestick-series .highcharts-point {
    stroke: #000000;
    stroke-width: 1px;
  }
  
  .highcharts-candlestick-series .highcharts-point-up {
    fill: #ffffff;
  }
  
  .highcharts-ohlc-series .highcharts-point-hover {
    stroke-width: 3px;
  }
  
  .highcharts-flags-series .highcharts-point .highcharts-label-box {
    stroke: #999999;
    fill: #ffffff;
    transition: fill 250ms;
  }
  
  .highcharts-flags-series .highcharts-point-hover .highcharts-label-box {
    stroke: #000000;
    fill: #ccd6eb;
  }
  
  .highcharts-flags-series .highcharts-point text {
    fill: #000000;
    font-size: 0.9em;
    font-weight: bold;
  }
  
  /* Highmaps */
  .highcharts-map-series .highcharts-point {
    transition: fill 500ms, fill-opacity 500ms, stroke-width 250ms;
    stroke: #cccccc;
  }
  
  .highcharts-map-series .highcharts-point-hover {
    transition: fill 0ms, fill-opacity 0ms;
    fill-opacity: 0.5;
    stroke-width: 2px;
  }
  
  .highcharts-mapline-series .highcharts-point {
    fill: none;
  }
  
  .highcharts-heatmap-series .highcharts-point {
    stroke-width: 0;
  }
  
  .highcharts-map-navigation {
    font-size: 1.3em;
    font-weight: bold;
    text-align: center;
  }
  
  .highcharts-coloraxis {
    stroke-width: 0;
  }
  
  .highcharts-coloraxis-marker {
    fill: #999999;
  }
  
  .highcharts-null-point {
    fill: #f7f7f7;
  }
  
  /* 3d charts */
  .highcharts-3d-frame {
    fill: transparent;
  }
  
  /* Exporting module */
  .highcharts-contextbutton {
    fill: #ffffff;
    /* needed to capture hover */
    stroke: none;
    stroke-linecap: round;
  }
  
  .highcharts-contextbutton:hover {
    fill: #e6e6e6;
    stroke: #e6e6e6;
  }
  
  .highcharts-button-symbol {
    stroke: #666666;
    stroke-width: 3px;
  }
  
  .highcharts-menu {
    border: 1px solid #999999;
    background: #ffffff;
    padding: 5px 0;
    box-shadow: 3px 3px 10px #888;
  }
  
  .highcharts-menu-item {
    padding: 0.5em 1em;
    background: none;
    color: #333333;
    cursor: pointer;
    transition: background 250ms, color 250ms;
  }
  
  .highcharts-menu-item:hover {
    background: #335cad;
    color: #ffffff;
  }
  
  /* Drilldown module */
  .highcharts-drilldown-point {
    cursor: pointer;
  }
  
  .highcharts-drilldown-data-label text,
  text.highcharts-drilldown-data-label,
  .highcharts-drilldown-axis-label {
    cursor: pointer;
    fill: #003399;
    font-weight: bold;
    text-decoration: underline;
  }
  
  /* No-data module */
  .highcharts-no-data text {
    font-weight: bold;
    font-size: 12px;
    fill: #666666;
  }
  
  /* Drag-panes module */
  .highcharts-axis-resizer {
    cursor: ns-resize;
    stroke: black;
    stroke-width: 2px;
  }
  
  /* Bullet type series */
  .highcharts-bullet-target {
    stroke-width: 0;
  }
  
  /* Lineargauge type series */
  .highcharts-lineargauge-target {
    stroke-width: 1px;
    stroke: #333333;
  }
  
  .highcharts-lineargauge-target-line {
    stroke-width: 1px;
    stroke: #333333;
  }
  
  /* Annotations module */
  .highcharts-annotation-label-box {
    stroke-width: 1px;
    stroke: #000000;
    fill: #000000;
    fill-opacity: 0.75;
  }
  
  .highcharts-annotation-label text {
    fill: #e6e6e6;
  }
  
  /* Gantt */
  .highcharts-treegrid-node-collapsed, .highcharts-treegrid-node-expanded {
    cursor: pointer;
  }
  
  .highcharts-point-connecting-path {
    fill: none;
  }
  
  .highcharts-grid-axis .highcharts-tick {
    stroke-width: 1px;
  }
  
  .highcharts-grid-axis .highcharts-axis-line {
    stroke-width: 1px;
  }

.optionGroup {
  font-weight: bold;
}

.optionChild {
  padding-left: 15px;
}
 .highcharts-color-0 {
    fill: #3a6e31;
    stroke: #3a6e31;
}

.highcharts-color-1 {
    fill: #005092;
    stroke: #005092;
}

.highcharts-color-2 {
    fill: #00b3f6;
    stroke: #00b3f6;
}
.highcharts-color-3 {
    fill: #E06C00;
    stroke: #E06C00;
}
.highcharts-color-4 {
    fill: #e56284;
    stroke: #e56284;
}
.highcharts-color-5 {
    fill: #db5524;
    stroke: #db5524;
}
.highcharts-color-6 {
    fill: #66cccc;
    stroke: #66cccc;
}
.highcharts-color-7 {
    fill: #7f3705;
    stroke: #7f3705;
}
.highcharts-color-8 {
    fill: #95bf5d;
    stroke: #95bf5d;
}
</style>
<div class="instructionsContainer">Välj region, vårdförlopp och behandling</div>
<div id="guiChoices">
<span>
  <span id='regionselector'></span>
  <span id='svfselector'></span>
  <span id='treatmentselector'></span>
</span>
</div>
`;

class SVFLeadtimeTrend extends HighchartsComponentBase {
  constructor() {
    super(template);

    this.chartData = {
      chart: {
        type: 'spline',
        styledMode: true
      },
      title: {
        text: null,
        align: 'left'
      },
      accessibility: {
        description: "Diagram som visar hur många som startar behandling inom den angivna ledtiden, med fokus på utvecklingen över tid."
      },
      subtitle: {
        text: null,
        align: 'left'
      },
      data: {
        dateFormat: "YYYY/mm"
      },
      tooltip: {
        xDateFormat: "%Y-%m",

        useHTML: false,
        formatter: function () {
          let text = '<b>' + this.point['date'] + '</b> <br>'
          if (this.point['Andel inom angiven ledtid'] != undefined) {
            text += "Andel inom angiven ledtid: " + this.point['Andel inom angiven ledtid'] + ' % <br>'
            text += "Antal inom angiven ledtid: " + this.point['Antal inom angiven ledtid'] + ' <br>'
          }
          if (this.point['Andel med 1-25 % längre ledtid'] != undefined) {
            text += "Andel med 1-25 % längre ledtid: " + this.point['Andel med 1-25 % längre ledtid'] + ' %<br>';
            text += "Antal med 1-25 % längre ledtid: " + this.point['Antal med 1-25 % längre ledtid'] + '<br>';
          }
          if (this.point['Andel med 26-75 % längre ledtid'] != undefined) {
            text += "Andel med 26-75 % längre ledtid: " + this.point['Andel med 26-75 % längre ledtid'] + ' %<br>';
            text += "Antal med 26-75 % längre ledtid: " + this.point['Antal med 26-75 % längre ledtid'] + '<br>';
          }
          if (this.point['Andel med mer än 75 % längre ledtid'] != undefined) {
            text += "Andel med mer än 75 % längre ledtid: " + this.point['Andel med mer än 75 % längre ledtid'] + ' %<br>';
            text += "Antal med mer än 75 % längre ledtid: " + this.point['Antal med mer än 75 % längre ledtid'] + '<br>';
          }
          
          
          text += "Totalt antal: " + this.point['Totalt antal'] + '<br>';
          return text;
        }
      },

      loading: {
        hideDuration: 1000,
        showDuration: 1000
      },
      xAxis: {
        type: 'category',
        categories: [],
        title: {
          text: null
        }

      },
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: '',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        },
        reversedStacks: false
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        x: -40,
        y: 80,
        floating: false,
        borderWidth: 1,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
        shadow: true,
        reversed: false,
        useHTML: false
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        series: {
          marker: {
            enabled: true
          }
        }
      },
      lang: {
        loading: "Hämtar data...",
        accessibility: {
          chartContainerLabel: "Linjediagram. Visar andel patienter som har genomgått ett SVF inom angiven ledtid per region",
          chartTypes: {
            splineMultiple: "Linjediagram med {numPoints} {#plural(numPoints, linjer, linje)}",
          },
          axis: {
            xAxisDescriptionSingular: "Diagrammet har 1 X-axel som består av tidpunkter uppdelat på halvår",
            yAxisDescriptionSingular: "Diagrammet har 1 Y-axel som visar andel personer som genomgått behandling inom angiven ledtid. Intervall: 0 till 100"
          },
          screenReaderSection: {
            beforeRegionLabel: "Början av det interaktiva diagrammet",
            endOfChartMarker: "Slutet av det interaktiva diagrammet"
          },
          legend: {
            legendLabel: "Dölj eller visa regioner"
          }
        },
        contextButtonTitle: 'Diagram-meny',
        downloadJPEG: 'Ladda ned JPEG-bild',
        downloadPDF: 'Ladda ned PDF-dokument',
        downloadPNG: 'Ladda ned PNG-bild',
        downloadSVG: 'Ladda ned SVG-vektorgrafik',
        downloadCSV: 'Ladda ner CSV-fil',
        downloadXLS: 'Laddan ner Excel-fil',
        months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
        noData: 'Ingen data att visa',
        numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
        printChart: 'Skriv ut diagram',
        shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        thousandsSep: ' ',
        weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag']
      },
      exporting: {
        chartOptions: {
          chart: {
            styledMode: true,
          }
        },
        enabled: true,
        scale: 1,
        sourceHeight: 600,
        sourceWidth: 800,
        buttons: {
          contextButton: {
            menuItems: ["printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "openInCloud"]
          }
        }
      }
    };

    super.setChartOptions(this.chartData);

    let guiChoices = super.getShadow().querySelector("#guiChoices");
    let regionselector = guiChoices.querySelector('#regionselector');
    let svfselector = guiChoices.querySelector('#svfselector');
    let treatmentselector = guiChoices.querySelector('#treatmentselector');
    createRCCAndRegions(this, regionselector);
    createSVFAndTreatment(this, svfselector, treatmentselector);
  }

  loadChartData() {
    var options = "";
    if (!this.region) {
      options += "?centreId=" + this.centre;
      if (this.centre != "SWE") {
        options += "&aggregate=RCC";
      }
    } else {
      options += "?regionId=" + this.region;
    }
    if (this.treatmentcode) {
      options += "&codeId=" + this.treatmentcode;
    }
    if (this.service) {
      options += "&serviceId=" + this.service;
    }
    utils.loadJSONP(__BACKEND_URL__ + "/seam/resource/rest/homeRegion/intervalTrendSVFResult" + options, false).then((data) => {
      var series = [];

      let lowResponseWarning = false;
      console.log(data)
      let count = 0;
      data.xNames[0].forEach((name) => {
        let i = 0;
        let categoryIdx = 0;
        console.log(name)

        if (series[name] == undefined) {
          series[name] = new Array();
        }
        data.rows.forEach((val) => {

          let infoObj = {};

          for (let j = 1; j < data.columns.length; j++) {
            if (data.columns[j].name.search(name.split(' ')[0].toLowerCase()) != -1 || j == 1) {
              infoObj[data.columns[j].name] = val[j];
            }
          }
          infoObj.y = val[6 + count];
          if (infoObj.y == null) {
            infoObj.y = 0
          }
          infoObj.date = val[0];
          infoObj.category = val[0];
          // Set categories to show month and year on xaxis
          this.chartData.xAxis.categories[categoryIdx++] = data.rows[i][0];
          if (infoObj['Totalt antal'] < 10) {
            lowResponseWarning = true;
          }
          i++;
          series[name].push(infoObj);
        });
        count++;
      })
      //console.log(series)
      var idx = 0;
      for (const [key, value] of Object.entries(series)) {
        var point = [];
        for (var j = 0; j < value.length; j++) {
          point.push(value[j]);
        }
        super.addSeries(key, point)
        console.log(point)
        idx++;
      }
      super.render();
      if (lowResponseWarning) {
        super.setSubtitle('Data dold för vissa år p.g.a. färre än 5 patienter i urvalet');
      }
    }).catch((error) => {
      super.errorNoData("#chartContainer");
      console.error(error);
    });
    super.showLoading(true);
  }

  connectedCallback() {
    this.centre = 'SWE';
    this.treatmentcode = '';
  }
  static get observedAttributes() {
    return ['region', 'centre', 'service', 'treatmentcode'];
  }

  get region() {
    return this.getAttribute('region');
  }
  set region(value) {
    this.setAttribute('region', value);
  }
  get centre() {
    return this.getAttribute('centre');
  }
  set centre(value) {
    this.setAttribute('centre', value);
  }
  get service() {
    return this.getAttribute('service');
  }
  set service(value) {
    this.setAttribute('service', value);
  }
  get treatmentcode() {
    return this.getAttribute('treatmentcode');
  }
  set treatmentcode(value) {
    this.setAttribute('treatmentcode', value);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'region') {
      return;
    }
    if (name == 'service' && newVal != oldVal) {
      this.treatmentcode = ''
      return;
    }

    this.loadChartData();
  }

}
customElements.define('svf-ledtid-trend', SVFLeadtimeTrend);

